<mat-card *ngIf="!updateMode">{{'addSubCategory' | translate}}</mat-card>
<mat-card *ngIf="updateMode">{{'updateSubCategory' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
    <span class="spacer"></span>

    <button mat-raised-button color="primary" (click)="submit()" *ngIf="!_submit"
        [disabled]="arabName.invalid || engName.invalid">
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button (click)="back()">
        <mat-icon>keyboard_backspace</mat-icon>
        {{'back' | translate}}
    </button>
    &nbsp;
</div>

<mat-grid-list cols="5" rowHeight="100px">

    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'arabicName' | translate}}</mat-label>
            <input matInput [(ngModel)]="subCategory.aDesc" required #arabName="ngModel" name="arabicName">
            <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error>
        </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'englishName' | translate}}</mat-label>
            <input matInput [(ngModel)]="subCategory.eDesc" required #engName="ngModel" name="englishName">
            <mat-error *ngIf="engName.invalid">{{'requiredField' | translate}}</mat-error>
        </mat-form-field>
    </mat-grid-tile>
    <mat-grid-tile colspan="1">
        <mat-checkbox *ngIf="updateMode" class="example-margin" [(ngModel)]="active" name="active">{{'active' |
            translate}}
        </mat-checkbox>
    </mat-grid-tile>

    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'email' | translate}}</mat-label>
            <input matInput [(ngModel)]="subCategory.email" readonly>
        </mat-form-field>

    </mat-grid-tile>

    <mat-grid-tile colspan="2">
        <mat-form-field appearance="standard">
            <mat-label>{{'phone' | translate}}</mat-label>
            <input matInput [(ngModel)]="subCategory.phone" readonly>
        </mat-form-field>

    </mat-grid-tile>


</mat-grid-list>


<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>